// Generate a unique device ID
export const getDeviceId = (): string => {
  let deviceId = window.localStorage.getItem('device_id');
  if (!deviceId) {
    deviceId = `device_${Date.now().toString().replaceAll('-', '').replaceAll(':', '').replaceAll('T', '').replaceAll('Z', '').substring(0, 15)}`;
    window.localStorage.setItem('device_id', deviceId);
  }
  return deviceId;
};

// Get device-specific storage key
export const getDeviceKey = (key: string): string => {
  const deviceId = getDeviceId();
  return `${deviceId}_${key}`;
};

// Utility function for safe localStorage access
export const getLocalStorageItem = (key: string): string | null => {
  try {
    const deviceKey = getDeviceKey(key);
    return window.localStorage.getItem(deviceKey);
  } catch (error) {
    console.error(`Error accessing localStorage for key ${key}:`, error);
    return null;
  }
};

export const setLocalStorageItem = (key: string, value: string): void => {
  try {
    const deviceKey = getDeviceKey(key);
    window.localStorage.setItem(deviceKey, value);
  } catch (error) {
    console.error(`Error setting localStorage for key ${key}:`, error);
  }
};
